import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from '../lib/query-client.js';
import { AuthProvider } from '../features/auth/AuthProvider.js';
import { CurrencyProvider } from '../features/currency/CurrencyProvider.js';
import { ErrorBoundary } from '../components/ErrorBoundary.js';

/**
 * Provider order matters: the query client sits outermost because auth clears
 * its cache on sign-out, and currency sits innermost because it loads FX rates
 * through a query that only makes sense once a session exists.
 */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CurrencyProvider>{children}</CurrencyProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
